import React from 'react';

import { PixleeOutsideButtonGroup } from 'features/pixlee/desktop';
import { Carousel } from 'components/Carousel';

import './InspireHomeDecorCarousel.scss';
import { homeAndProsResponsiveConfig, list } from './constants';

function InspireHomeDecorCarousel ({}) {

	return (
		<Carousel
			className="InspireHomeDecorCarousel"
			renderButtonGroupOutside
			responsive={homeAndProsResponsiveConfig}
			slidesToSlide={1}
			arrows={false}
			swipeable={false}
			draggable={false}
			customButtonGroup={<PixleeOutsideButtonGroup buttonGroupClassName="inspireHomeDecor" slidesToSlide={1} />}
		>
			{list
				? list.map((item, index) => (
					<div className="eachTip" key={item}>
						<div className="tipText">
							<div className="textWrapper">
								<h2>My Lighting Tips</h2>
								<p>
									{item.tipText}
								</p>
							</div>
						</div>
						<div className="tipImg">
							<img src={item.thumbnailUrl} alt="" />
						</div>
					</div>
				  ))
				: []}
		</Carousel>
	);

}

export default InspireHomeDecorCarousel;
